import { NgModule } from "@angular/core";
import { TogglePasswordButton } from "./toggle-password/toggle-password.component";

@NgModule({
    declarations: [
        TogglePasswordButton,
    ],
    exports: [
        TogglePasswordButton
    ]
})
export class ButtonModule { }
